/**
 * Lib.Common: Layout component declarations
 */


import ibCarousel           from './ib-carousel.vue';
import ibCol                from './ib-col.vue';
import ibContainer          from './ib-container.vue';
import ibContext            from './ib-context.vue';
import ibRow                from './ib-row.vue';
import ibOverflow           from './ib-overflow.vue';
import ibTab                from './ib-tab.vue';
import ibTab2               from './ib-tab2.vue';
import ibTabBar             from './ib-tab-bar.vue';
import ibTabContainer       from './ib-tab-container.vue';
import ibTabPane            from './ib-tab-pane.vue';


export default [
    ibCarousel,
    ibCol,
    ibContainer,
    ibContext,
    ibRow,
    ibOverflow,
    ibTab,
    ibTab2,
    ibTabBar,
    ibTabContainer,
    ibTabPane
];
